import React, { useContext } from "react";

interface FormWrapperContextType {
    registerKeyDownHandler?: React.Dispatch<React.SetStateAction<(e: React.KeyboardEvent<HTMLElement>) => void>>;
}

export const FormWrapperContext = React.createContext<FormWrapperContextType | null>(null);


export function useFormWrapper() {
    const context = useContext(FormWrapperContext);
    if (!context) {
        throw new Error('useFormWrapper must be used within a FormWrapperProvider');
    }
    return context;
}

interface FormWrapperProviderProps extends FormWrapperContextType {
    children: React.ReactNode;
} 

export function FormWrapperProvider({ children, registerKeyDownHandler }: 
    FormWrapperProviderProps
) {

    return (
        <FormWrapperContext.Provider value={{ registerKeyDownHandler }}>
            {children}
        </FormWrapperContext.Provider>
    )
}